module.exports = __webpack_public_path__ + "static/media/checkout.1078317d.svg";